import React, { useCallback, useReducer } from 'react';

const tooltipSteps = {
  first: {
    step: 1,
    title: 'Collaboration activated',
    text: 'You have activated the "Collaborate with renter" option.',
    tooltipPath: '/settings/cooperation',
  },
  second: {
    step: 2,
    title: 'Partners activated',
    text: 'You have activated the "Partners" in the main navigation.',
    tooltipPath: '/accommodations/partners',
  },
};

const initialState = {
  step: tooltipSteps.first,
  isTooltipVisible: false,
};

export const TooltipsContext = React.createContext({
  state: { ...initialState },
});

const SHOW_TOOLTIP = 'SHOW_TOOLTIP';
const SET_SECOND_STEP = 'SET_SECOND_STEP';
const HIDE_TOOLTIP = 'HIDE_TOOLTIP';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_TOOLTIP:
      return { ...state, isTooltipVisible: true };
    case SET_SECOND_STEP:
      return { ...state, step: tooltipSteps.second };
    case HIDE_TOOLTIP:
      return { ...state, isTooltipVisible: false, step: tooltipSteps.first };
    default:
      return new Error(`${action.type} does not exist in reducer!`);
  }
};

const TooltipsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setSecondStep = () => {
    return dispatch({ type: SET_SECOND_STEP });
  };
  const hideTooltip = useCallback(() => {
    return dispatch({ type: HIDE_TOOLTIP });
  }, []);
  const showTooltip = () => {
    return dispatch({ type: SHOW_TOOLTIP });
  };

  const value = {
    state,
    setSecondStep,
    hideTooltip,
    showTooltip,
    tooltipSteps,
  };

  return <TooltipsContext.Provider value={value}>{children}</TooltipsContext.Provider>;
};

export default TooltipsProvider;
